import React, { ChangeEvent, Fragment, useState, useCallback, useEffect, useContext } from "react";
import { getUserWorkTeam } from "services/NexiDigitalAPI";
import PreloaderBlur from "containers/PeopleCraft/PreloaderBlur";
import InputFilter from "../../../components/InputFilter";
import FilterResults from "react-filter-search";
import AccordionTable from "../../../components/AccordionTable";
import { AuthContext } from "context/AuthContext";

interface User {
  id: string;
  name: string;
}

const IndividualAssessmentsTab: React.FC = () => {
  const { loginData }: { loginData: any } = useContext(AuthContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [textSearch, setTextSearch] = useState<string>("");

  const fetchUserWorkTeam = useCallback(async () => {
    if (!loginData?.userid) {
      setError("Dados de login não disponíveis");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getUserWorkTeam(loginData.userid, {
        onlyWithPendingEvaluation: true,
      });
      setUsers(response?.data?.result || []);
    } catch (err) {
      console.error("Erro ao buscar equipe:", err);
      setError("Erro ao carregar dados da equipe");
    } finally {
      setLoading(false);
    }
  }, [loginData?.userid]);

  useEffect(() => {
    fetchUserWorkTeam();
  }, [fetchUserWorkTeam]);

  const handleChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    setTextSearch(e.target?.value);
  };

  const cleanSearch = () => {
    setTextSearch("");
  };

  return (
    <>
      {loading && <PreloaderBlur />}
      <p>Algumas avaliações podem ter sido criadas quando o colaborador ainda era da sua equipe. Você ainda precisa respondê-las.</p>
      <InputFilter
        textSearch={textSearch}
        handleChangeName={handleChangeName}
        cleanSearch={cleanSearch}
      />
      <div className="accordionTeam" style={{ marginTop: 10 }}>
        <FilterResults
          value={textSearch}
          data={
            !!textSearch
              ? users.filter((item) => item.name.toLowerCase().indexOf(textSearch) > -1)
              : users
          }
          renderResults={(results) => (
            <>
              {results.length === 0 && !loading && <p>Não foi encontrado nenhum dado</p>}
              {results.map((item) => (
                <Fragment key={item.idUser}>
                  <AccordionTable item={item} idUser={item.idUser} />
                </Fragment>
              ))}
            </>
          )}
        />
      </div>
    </>
  );
};

export default IndividualAssessmentsTab;
